
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import EditFreight from './mainlandpackage-edit.vue'
    import CreateFreight from './mainlandpackage-add.vue'
    // 导入打印条形码组件
    import BackPrinting from '@/views/back/stock/back-printing.vue'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import moment from 'moment'
    Vue.use(Preview);

    class PageFreightRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        mainLandInterNationalShipment: string;
        cargoCategory: number;
        isSend?: boolean;
        constructor() {
            super();
            this.isSend = null;
        }
    }

    @Component
        ({
            name: "mainlandpackageList",
            components: { CreateFreight, EditFreight, BackPrinting } // 添加BackPrinting组件
        })
    export default class Freogjt extends AbpBase {
        whetherStatus = Enums.getEnum(Enums.IsSend, true);
        cargoCategoryType = Enums.getEnum(Enums.CargoCategoryType, true);
        pagerequest: PageFreightRequest = new PageFreightRequest();
        completeStatus = Enums.getEnum(Enums.completeStatus, true);
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        editModalShow: boolean = false;
        createModalShow: boolean = false;
        printingModalShow: boolean = false; // 添加打印弹窗控制属性

        get list() {
            return this.$store.state.mainlandpackage.list;
        };
        get loading() {
            return this.$store.state.mainlandpackage.loading;
        }

        create() {
            this.createModalShow = true;
        }
        pageChange(page: number) {
            this.$store.commit('mainlandpackage/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('mainlandpackage/setPageSize', pagesize);
            this.getpage();
        }
        async update(data: any) {

            this.$store.state.mainlandpackage.MainLandPackageList = data;
            this.editModalShow = true;

            var _this: any = this;
            //_this.$previewRefresh();
        }
        async updateStatus(data: any) {
            // 添加确认对话框
            this.$Modal.confirm({
                title: '操作确认',
                content: '<p style="color:#ed4014; font-weight:bold">是否确认变更为已完成？</p><p>变更为完成后，将自动扣除快递称重费用，<span style="color:#ed4014">此操作不可逆！</span></p>',
                okText: '确认变更',
                cancelText: '取消',
                onOk: async () => {
                    await this.$store.dispatch({
                        type: 'mainlandpackage/editCompleteStatus',
                        data: data
                    });

                    // 成功后提示
                    this.$Message.success('状态更新成功，已扣除称重费用');

                    // 刷新列表
                    this.getpage();
                },
                onCancel: () => {
                    this.$Message.info('已取消操作');
                }
            });
        }

        // 添加打印条形码方法
        async printing(data: any) {
            var count = await this.$store.dispatch({
                type: 'mainlandpackage/getPackCount',
                data: {id:data.id}
            });
            this.$store.state.backstockproduct.barCode = data.packageName;
            this.$store.state.backstockproduct.isMainlandpackage = true;
            this.$store.state.backstockproduct.packCount = count;
            this.printingModalShow = true;
        }

        async displayPdf(data: any) {
            var count = await this.$store.dispatch({
                type: 'mainlandpackage/getPackCount',
                data: { id: data.id }
            });

            var pdfData = {
                barCode: data.packageName,
                packCount: count,
                url:'',
            };
            pdfData.url = await this.$store.dispatch({
                type: 'mainlandpackage/getPdfUrl',
                data: pdfData
            });
            window.open(pdfData.url);
        }

        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters
            if (this.creationTime.length > 0) {
                this.pagerequest.beginTime = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endTime = this.creationTime[1];
            }

            await this.$store.dispatch({
                type: 'mainlandpackage/getAll',
                data: this.pagerequest
            })
        }
        get pageSize() {
            return this.$store.state.mainlandpackage.pageSize;
        }
        get totalCount() {
            return this.$store.state.mainlandpackage.totalCount;
        }
        get currentPage() {
            return this.$store.state.mainlandpackage.currentPage;
        }

        columns = [
            {
                type: 'selection',
                width: 50,
                align: 'center',
                fixed: 'left',
            }, {
                title: '仓库',
                key: 'warehouseName',
                width: 120,
                fixed: 'left',
            },
            {
                title: '包裹名称',
                key: 'packageName',
                width: 250,
            }, {
                title: '货物类别',
                width: 120,
                key: 'cargoCategory',
                render: (h: any, params: any) => {
                    return h('span', Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name);
                }
            },
            {
                title: '完成状态',
                width: 120,
                key: 'completeStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.completeStatus.filter(function (item) { return item.value == params.row.completeStatus })[0].name);
                }
            },
            //{
            //    title: '包裹基本信息',
            //    key: '',
            //    width: 250,
            //    render: (h: any, params: any) => {
            //        return h('span', "长：" + (params.row.long == 0 ? "" : params.row.long) + "cm," + "宽：" + (params.row.wide == 0 ? "" : params.row.wide) + "cm," + "高：" + (params.row.high == 0 ? "" : params.row.high)+"cm")
            //    }
            //},
            //{
            //    title: '重量【g】',
            //    key: 'weight',
            //    width: 120,
            //},
            {
                title: '麻袋编号',
                key: 'mainLandInterNationalShipment',
                width: 180,
            }
            //{
            //    title: '是否已发送',
            //    width: 100,
            //    key: 'isSend',
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.isSend ? this.L('是') : this.L('否'))
            //    }
            //}
            , {
                title: '创建时间',
                key: 'createTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.createTime ? DateUtils.formatLongDate(new Date(params.row.createTime)) : '');
                }
            }, {
                title: '更新时间',
                key: 'updateTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.updateTime ? DateUtils.formatLongDate(new Date(params.row.updateTime)) : '');
                }
            }, {
                title: '创建人',
                key: 'createUserName',
                width: 150,
            }, {
                title: '更新人',
                key: 'updateUserName',
                width: 150,
            }, {
                title: '指定人',
                key: 'appointUserName',
                width: 150,
            }, {
                title: '操作',
                width: 160, // 增加宽度以容纳新按钮
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var completeStatus = Enums.completeStatus.filter(function (item) { return item.value == data.completeStatus })[0].name;
                    var _this = this;
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '70px',
                                height: '30px',
                                marginRight: '5px',
                                //display: data.isEffective == true ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {

                                    this.update(data);
                                }
                            }

                        }, "修改"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {

                                marginTop: '5px',
                                width: '70px',
                                height: '30px',
                                marginBottom: '5px',
                                marginRight: '5px',
                                display: (completeStatus == "未完成") ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    this.updateStatus(data);
                                }
                            }

                        }, "已完成"),
                        // 添加打印条形码按钮
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '70px',
                                height: '30px',
                                marginBottom: '5px',
                                display: data.mainLandInterNationalShipment ? "inline-block" : "none", // 有麻袋编号才显示
                            },
                            on: {
                                click: () => {
                                    this.printing(data);
                                }
                            }

                        }, "打印条码"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '70px',
                                height: '30px',
                                marginBottom: '5px',
                                display: data.mainLandInterNationalShipment ? "inline-block" : "none", // 有麻袋编号才显示
                            },
                            on: {
                                click: () => {
                                    this.displayPdf(data);
                                }
                            }

                        }, "查看条码")
                    ]);
                }
            }]
        async created() {
            this.getpage();
        }
    }
